import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class VideoCallStateService {
  public drawerOpened = signal(false);
  public chatPaneState = signal<'closed' | 'open'>('closed');
  public whiteboardOpened = signal(false);
  public preventDrawerClose = signal(false);
  public activeCallId = signal<string | null>(null);

  private toast = inject(ToastService);
  private translate = inject(TranslateService);

  private toggleDrawerSource = new Subject<boolean>();
  public toggleDrawer$ = this.toggleDrawerSource.asObservable();

  public toggleDrawer(): void {
    if (this.drawerOpened() && this.preventDrawerClose()) {
      this.showCallInProgressWarning();
      return;
    }
    const nextState = !this.drawerOpened();
    this.drawerOpened.set(nextState);
    this.toggleDrawerSource.next(nextState);
  }

  public closeDrawer(): void {
    if (this.preventDrawerClose()) {
      this.showCallInProgressWarning();
      return;
    }
    this.drawerOpened.set(false);
    this.toggleDrawerSource.next(false);
  }

  private showCallInProgressWarning(): void {
    const message = this.translate.instant('VideoCall.Warning.CannotCloseDrawerDuringCall');
    this.toast.snackbar.open(message, 'Close', {
      duration: 5000,
    });
  }

  public openDrawer(): void {
    this.drawerOpened.set(true);
    this.toggleDrawerSource.next(true);
  }

  public openChatPane(): void {
    this.chatPaneState.set('open');
    this.whiteboardOpened.set(false);
  }

  public closeChatPane(): void {
    this.chatPaneState.set('closed');
  }

  public openWhiteboard(): void {
    this.whiteboardOpened.set(true);
    this.chatPaneState.set('closed');
  }

  public closeWhiteboard(): void {
    this.whiteboardOpened.set(false);
  }

  public toggleWhiteboard(): void {
    const next = !this.whiteboardOpened();
    this.whiteboardOpened.set(next);
    if (next) {
      this.chatPaneState.set('closed');
    }
  }
}
